import styled from "styled-components";

export const StyledList = styled.div<{
  $gapElementList: number;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  gap: ${({ $gapElementList }) => `${$gapElementList}px`};
  height: 100%;
`;

export const StyledObserverTarget = styled.div`
  flex-shrink: 0;
  height: 40px;
`;
